var _defs, _path, _path2, _path3, _path4, _polygon, _path5, _path6, _path7, _path8, _path9, _path10, _line, _path11, _path12, _path13, _path14, _path15, _rect, _rect2, _rect3, _rect4, _path16, _path17, _path18, _path19, _rect5, _rect6, _rect7, _rect8, _path20, _path21, _path22, _path23, _rect9, _rect10, _rect11, _rect12, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObj0Mvl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 731 356.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aae2c2;}.cls-2{fill:#50bd86;}.cls-3{fill:#434341;}.cls-4{fill:#fff;}.cls-5{fill:#ffdc00;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.27,44.31c-1,6.19-1.9,12.41-3.1,18.57-4.34,22.37-16.66,39.7-34,53.9-11,9-21.83,18.32-32.84,27.37a6,6,0,0,0-2.49,5.31c.13,7.95.11,15.89,0,23.84a4.88,4.88,0,0,1-1.4,3.52c-5.8,4.1-11.76,8-18.05,12.17-1.87-6.81-3.65-13.3-5.42-19.78-1-3.56-2.45-4.61-5.42-2.65-6.38,4.22-11.43,2.21-16.06-2.64-3.69-3.88-7.25-7.89-10.71-12a5.93,5.93,0,0,1-.66-7.46A20.83,20.83,0,0,0,44.71,141c1.12-2.92.1-4.89-2.94-5.72-6.37-1.77-12.74-3.51-19.48-5.36,4.24-6.36,8.17-12.4,12.31-18.3.56-.79,2.18-1.15,3.32-1.16,7.71-.1,15.42-.15,23.13,0a6.18,6.18,0,0,0,5.28-2.59c11.48-13.37,23-26.76,34.68-39.94,14-15.78,32.33-23.69,52.58-27.77C158,39.27,162.5,38.71,167,38h6.31ZM127.38,70.88A13.16,13.16,0,0,0,114,83.8a13.37,13.37,0,0,0,13.27,13.47,13.21,13.21,0,0,0,13.1-13.21A13,13,0,0,0,127.38,70.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.48,186c.72-3.63,1.29-7.29,2.16-10.87,2.4-9.88,6.75-18.59,15.34-24.83,2.15,1.59,1.84,3.07.49,5.18-5.6,8.76-7.12,18.54-6.89,29.18,10.57.39,20.34-1.31,29.27-6.78,2.52-1.54,2.51-1.57,5.22.28-6.13,8.7-14.93,13.06-24.9,15.49-3.58.88-7.24,1.45-10.87,2.16H15.48Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M215.44,295.38A100.59,100.59,0,1,0,114.79,194.79,100.62,100.62,0,0,0,215.44,295.38Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M215.44,297.36A102.57,102.57,0,1,1,318.07,194.79,102.71,102.71,0,0,1,215.44,297.36Zm0-201.17a98.6,98.6,0,1,0,98.66,98.6A98.74,98.74,0,0,0,215.44,96.19Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "326.34 112.47 300.83 110.76 298.74 84.87 335.38 48.23 337.28 73.92 362.98 75.83 326.34 112.47"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M327.11,114.51,299,112.62l-2.3-28.5L337,43.76l2.1,28.31,28.31,2.1Zm-24.44-5.62,22.9,1.54,32.95-32.94-23.09-1.71-1.71-23.09L300.79,85.62Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.44,274.41a79.62,79.62,0,1,0-79.66-79.62A79.65,79.65,0,0,0,215.44,274.41Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M215.44,250.28a55.49,55.49,0,1,0-55.53-55.49A55.5,55.5,0,0,0,215.44,250.28Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M215.44,252.27A57.48,57.48,0,1,1,273,194.79,57.56,57.56,0,0,1,215.44,252.27Zm0-111A53.51,53.51,0,1,0,269,194.79,53.59,53.59,0,0,0,215.44,141.28Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M215.44,222.6a27.81,27.81,0,1,0-27.83-27.81A27.82,27.82,0,0,0,215.44,222.6Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M215.44,224.59a29.8,29.8,0,1,1,29.81-29.8A29.84,29.84,0,0,1,215.44,224.59Zm0-55.63a25.83,25.83,0,1,0,25.84,25.83A25.86,25.86,0,0,0,215.44,169Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 216.08,
    y1: 194.21,
    x2: 336.49,
    y2: 73.81
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M216.08,196.2a2,2,0,0,1-1.4-.58,2,2,0,0,1,0-2.81L335.09,72.4a2,2,0,1,1,2.8,2.81L217.48,195.62A1.94,1.94,0,0,1,216.08,196.2Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.52,252.94a1.28,1.28,0,0,1-.76-.25,1.29,1.29,0,0,1-.28-1.81l10.13-13.79a1.29,1.29,0,1,1,2.08,1.53L54.56,252.41A1.27,1.27,0,0,1,53.52,252.94Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.09,279.41a1.28,1.28,0,0,1-.76-.25,1.3,1.3,0,0,1-.28-1.81l10.13-13.79a1.29,1.29,0,1,1,2.08,1.53L35.14,278.88A1.3,1.3,0,0,1,34.09,279.41Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.9,254.85a1.26,1.26,0,0,1-.76-.25l-13.8-10.12a1.29,1.29,0,1,1,1.53-2.08l13.79,10.12a1.29,1.29,0,0,1-.76,2.33Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.37,274.28a1.26,1.26,0,0,1-.76-.25l-13.8-10.12a1.29,1.29,0,1,1,1.53-2.08L70.13,272a1.28,1.28,0,0,1,.28,1.8A1.27,1.27,0,0,1,69.37,274.28Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.7,
    y: 233.55,
    width: 2.58,
    height: 12.95,
    transform: "matrix(0.99, -0.15, 0.15, 0.99, -35.87, 9.75)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.31,
    y: 270.12,
    width: 2.58,
    height: 12.95,
    transform: "matrix(0.99, -0.15, 0.15, 0.99, -41.35, 11.02)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.46,
    y: 259.72,
    width: 12.95,
    height: 2.58,
    transform: "translate(-39.28 7.73) rotate(-8.74)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 61.02,
    y: 254.11,
    width: 12.95,
    height: 2.58,
    transform: "translate(-38.01 13.21) rotate(-8.74)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M433.34,80a1.29,1.29,0,0,1-1.29-1.27l-.44-29.58a1.29,1.29,0,0,1,2.58,0l.44,29.58A1.27,1.27,0,0,1,433.36,80Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434.2,136.8a1.29,1.29,0,0,1-1.29-1.27L432.46,106a1.29,1.29,0,0,1,1.27-1.31,1.26,1.26,0,0,1,1.31,1.27l.45,29.58a1.29,1.29,0,0,1-1.27,1.31Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391.12,94.21a1.29,1.29,0,0,1,0-2.58l29.58-.45a1.3,1.3,0,0,1,0,2.59l-29.58.44Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M447.88,93.36a1.3,1.3,0,0,1,0-2.59l29.58-.44a1.33,1.33,0,0,1,1.31,1.27,1.29,1.29,0,0,1-1.27,1.31l-29.59.45Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 409.53,
    y: 59.39,
    width: 2.58,
    height: 22.39,
    transform: "translate(74.07 316.26) rotate(-45.86)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 455.44,
    y: 103.94,
    width: 2.58,
    height: 22.39,
    transform: "translate(56.05 362.74) rotate(-45.86)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 400.79,
    y: 113.95,
    width: 22.39,
    height: 2.58,
    transform: "translate(42.41 330.71) rotate(-45.87)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 445.33,
    y: 68.04,
    width: 22.39,
    height: 2.58,
    transform: "translate(88.89 348.74) rotate(-45.87)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M393.56,283.75a1.29,1.29,0,0,1-1-2.05l10.13-13.8a1.29,1.29,0,0,1,2.08,1.53l-10.13,13.8A1.28,1.28,0,0,1,393.56,283.75Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.14,310.22a1.28,1.28,0,0,1-1-2.05l10.12-13.8a1.29,1.29,0,0,1,2.08,1.53l-10.12,13.8A1.31,1.31,0,0,1,374.14,310.22Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M382.94,285.67a1.26,1.26,0,0,1-.76-.25l-13.8-10.12a1.3,1.3,0,0,1,1.53-2.09l13.79,10.13a1.28,1.28,0,0,1,.28,1.8A1.27,1.27,0,0,1,382.94,285.67Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M409.41,305.1a1.26,1.26,0,0,1-.76-.25l-13.8-10.13a1.29,1.29,0,0,1,1.53-2.08l13.79,10.12a1.3,1.3,0,0,1-.76,2.34Z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 384.74,
    y: 264.36,
    width: 2.58,
    height: 12.95,
    transform: "translate(-36.61 61.68) rotate(-8.72)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 390.35,
    y: 300.93,
    width: 2.58,
    height: 12.95,
    transform: "translate(-42.09 62.94) rotate(-8.72)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 364.5,
    y: 290.54,
    width: 12.95,
    height: 2.58,
    transform: "translate(-39.96 59.63) rotate(-8.72)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 401.06,
    y: 284.93,
    width: 12.95,
    height: 2.58,
    transform: "translate(-38.69 65.11) rotate(-8.72)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M493.8,131.4H500l14.35,15v-15h9.27v31.49h-6.52l-14.09-15v15H493.8Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M529.48,131.4H539v18a5.73,5.73,0,0,0,1.37,4,4.68,4.68,0,0,0,3.62,1.5,4.56,4.56,0,0,0,3.56-1.5,5.76,5.76,0,0,0,1.35-4v-18h9.49v18.89a12.55,12.55,0,0,1-4,9.66q-4,3.66-10.44,3.67A14.93,14.93,0,0,1,533.49,160a12.48,12.48,0,0,1-4-9.66Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M564.27,131.4h24.3v8H573.76v3.74H586.5v7.74H573.76v4H589v8H564.27Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M592.48,131.4h10.35l6.93,19.21,6.8-19.21h10.35L614,162.89h-8.5Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M632.71,135.31a17.16,17.16,0,0,1,23.45,0,17.55,17.55,0,0,1,0,23.67,17.13,17.13,0,0,1-23.45,0,17.55,17.55,0,0,1,0-23.67Zm6.82,17.39a6.17,6.17,0,0,0,4.88,2.18,6.26,6.26,0,0,0,4.91-2.18,9,9,0,0,0,0-11.11,6.26,6.26,0,0,0-4.91-2.18,6.17,6.17,0,0,0-4.88,2.18,9,9,0,0,0,0,11.11Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M463.9,189.31a17.15,17.15,0,0,1,23.44,0,17.55,17.55,0,0,1,0,23.67,17.12,17.12,0,0,1-23.44,0,17.55,17.55,0,0,1,0-23.67Zm6.81,17.39a6.59,6.59,0,0,0,9.79,0,8.92,8.92,0,0,0,0-11.11,6.59,6.59,0,0,0-9.79,0,9,9,0,0,0,0,11.11Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M512.32,185.4a13.61,13.61,0,0,1,8.59,2.54,8,8,0,0,1,3.29,6.59,8.63,8.63,0,0,1-2.52,6.12,8.49,8.49,0,0,1,3.42,6.89,8.19,8.19,0,0,1-3.36,6.75,13.82,13.82,0,0,1-8.75,2.6H497V185.4Zm-5.85,8v3.83h5.76a2.7,2.7,0,0,0,1.8-.57,1.71,1.71,0,0,0,.67-1.37,1.66,1.66,0,0,0-.67-1.35,2.8,2.8,0,0,0-1.8-.54Zm0,11.3v4.22H513a2.89,2.89,0,0,0,1.91-.58,2,2,0,0,0,.7-1.58,1.87,1.87,0,0,0-.72-1.46,2.86,2.86,0,0,0-1.89-.6Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M527.3,208.17a9.07,9.07,0,0,0,3.65.71c3,0,4.45-1.43,4.45-4.31V185.4h9.54v20.65a10.85,10.85,0,0,1-3.46,8.37,12.83,12.83,0,0,1-9.05,3.2q-3.73,0-5.13-1Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M550.84,185.4h24.3v8H560.33v3.74h12.74v7.74H560.33v4h15.26v8H550.84Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M598.27,193.36v23.53h-9.5V193.36h-9.49v-8h28.48v8Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M612.22,185.4h9.49v31.49h-9.49Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M625.89,185.4h10.35l6.93,19.21L650,185.4h10.35L647.4,216.89h-8.5Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M666.12,189.31a17.16,17.16,0,0,1,23.45,0,17.55,17.55,0,0,1,0,23.67,17.13,17.13,0,0,1-23.45,0,17.55,17.55,0,0,1,0-23.67Zm6.82,17.39a6.19,6.19,0,0,0,4.88,2.18,6.26,6.26,0,0,0,4.91-2.18,9,9,0,0,0,0-11.11,6.26,6.26,0,0,0-4.91-2.18,6.19,6.19,0,0,0-4.88,2.18,9,9,0,0,0,0,11.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObj0Mvl);
export default __webpack_public_path__ + "static/media/Obj_0-mvl.28ef9bf36bf381fab4357ef6216d6952.svg";
export { ForwardRef as ReactComponent };